import React from 'react';
import UI from '../../commons/services/UI';
import createNavigationContainer
  from '../../commons/components/createNavigationContainer';
import TextInput from '../../commons/components/TextInput';
import { openSettingsModal, isPremium } from '../../commons/services/Wix';
import { params } from '../../commons/services/styles';
import { badgesById, getNormalizedBadgeId } from '../../commons/badges';

function BadgeSettings({ onUpdate, data }) {
  const selectedBadge = getNormalizedBadgeId(data.selectedBadge);
  const badgeColors = badgesById[selectedBadge].colors;

  return (
    <div>
      <UI.sectionDividerLabeled label="Sign Colors" />
      <hr className="divider-long" />

      <UI.toggleSwitch
        label="Use sign default colors"
        defaultValue={data.badgeDefaultColors}
        onChange={isOn => {
          onUpdate(data, { badgeDefaultColors: { $set: isOn } });
        }}
      />

      {!data.badgeDefaultColors &&
        badgeColors >= 1 &&
        <hr className="divider-long" />}

      {!data.badgeDefaultColors &&
        badgeColors >= 1 &&
        <UI.colorPickerInput
          title="First Color"
          disabled
          startWithColor="color-8"
          wix-param={params.badgeFirstColor}
        />}

      {!data.badgeDefaultColors &&
        badgeColors >= 2 &&
        <hr className="divider-short" />}

      {!data.badgeDefaultColors &&
        badgeColors >= 2 &&
        <UI.colorPickerInput
          title="Second Color"
          startWithColor="color-1"
          wix-param={params.badgeSecondColor}
        />}

      {!data.badgeDefaultColors &&
        badgeColors >= 3 &&
        <hr className="divider-short" />}

      {!data.badgeDefaultColors &&
        badgeColors >= 3 &&
        <UI.colorPickerInput
          title="Third Color"
          startWithColor="color-6"
          wix-param={params.badgeThirdColor}
        />}
    </div>
  );
}

function ModalPremiumTeaser({ onUpgradeClick }) {
  return (
    <div>
      <hr className="divider-long" />
      <UI.sectionDividerLabeled label="Table Settings" />
      <hr className="divider-long" />
      <div className="PremiumTeaserContainer">
        <div className="PremiumTeaserUpgradeSymbol">
          <UI.symbol name="premiumLarge" onClick={onUpgradeClick} />
        </div>
        Please upgrade to premium in order to have the business hour table settings available.
      </div>
    </div>
  );
}

function ModalSettings({ onUpdate, data }) {
  return (
    <div>
      <hr className="divider-long" />
      <UI.sectionDividerLabeled label="Table Colors + Fonts" />
      <hr className="divider-long" />

      <div className="CenterButton">
        <UI.button
          className="btn-confirm-primary Actions__PreviewButton"
          label="Preview Table"
          onClick={() => openSettingsModal('Business Hours | Table Preview')}
        />
      </div>

      <hr className="divider-long" />

      <UI.colorPickerInput
        title="Background Color"
        wix-param={params.modalBackgroundColor}
        startWithColor="color-1"
      />

      <hr className="divider-short" />

      <UI.tooltip
        value="In order to see this style in the preview, you need to add at least one note in the hours settings."
      >
        <UI.colorPickerInput
          title="Note Background Color"
          wix-param={params.modalNoteBackgroundColor}
          startWithColor="color-6"
        />
      </UI.tooltip>

      <hr className="divider-short" />

      <UI.fontAndColorPicker
        title="Headline"
        fontMinSize={12}
        fontMaxSize={22}
        startWithColor="color-5"
        startWithTheme="font_5"
        wix-param-font={params.modalHeadlineFont}
        wix-param={params.modalHeadlineColor}
      />

      <hr className="divider-short" />

      <UI.fontAndColorPicker
        title="Weekdays"
        fontMinSize={12}
        fontMaxSize={14}
        startWithColor="color-5"
        startWithTheme="font_8"
        startWithStyle={{ bold: true }}
        wix-param-font={params.modalWeekdaysFont}
        wix-param={params.modalWeekdaysColor}
      />

      <hr className="divider-short" />

      <UI.fontAndColorPicker
        title="Time Slots"
        fontMinSize={12}
        fontMaxSize={14}
        startWithColor="color-5"
        startWithTheme="font_8"
        wix-param-font={params.modalTimeSlotsFont}
        wix-param={params.modalTimeSlotsColor}
      />

      <hr className="divider-short" />

      <UI.fontAndColorPicker
        title="Notes"
        fontMinSize={12}
        fontMaxSize={14}
        startWithColor="color-5"
        startWithTheme="font_8"
        wix-param-font={params.modalNotesFont}
        wix-param={params.modalNotesColor}
        infoText="In order to see this style in the preview, you need to add at least one note in the hours settings."
      />

      <hr className="divider-short" />

      <TextInput
        value={data.tableHeadline || ''}
        title="Custom Table Headline"
        placeholder="e.g. My business hours"
        infoText={
          isPremium() ? 'Use this headline, instead of the default one.' : null
        }
        maxLength={30}
        invalidMessage="Limit reached"
        validator={val => (val || '').length < 30}
        onChange={newTableHeadline => {
          onUpdate(data, { tableHeadline: { $set: newTableHeadline } });
        }}
        disabled={!isPremium()}
      />

    </div>
  );
}

function DesignTab({ onUpgradeClick, data, onUpdate }) {
  return (
    <div>
      <BadgeSettings data={data} onUpdate={onUpdate} />
      {isPremium()
        ? <ModalSettings data={data} onUpdate={onUpdate} />
        : <ModalPremiumTeaser onUpgradeClick={onUpgradeClick} />}
      <div style={{ height: '200px' }} />
    </div>
  );
}

export default createNavigationContainer(DesignTab);



// WEBPACK FOOTER //
// ./src/apps/settings/DesignTab.jsx